// Burger Menu Components
export const BurgerMenu = (() => {
	const defaults = {
		selector: ".burger",
		stateAttribute: "data-state",
		expandedAttribute: "aria-expanded",
		openState: "opened",
		closedState: "closed",
		openClass: "is-open",
	};

	const body = document.body;

	// Force la fermeture
	const closeBurger = (button, config) => {
		const targetId = button.getAttribute("aria-controls");
		const target = document.querySelector(`#${targetId}`);

		button.setAttribute(config.stateAttribute, config.closedState);
		button.setAttribute(config.expandedAttribute, "false");
		target.classList.remove(config.openClass);

		body.classList.remove("burger-menu-open");
	};

	// Toggle ouverture/fermeture
	const toggleBurgerState = (button, config) => {
		const currentState = button.getAttribute(config.stateAttribute);
		const targetId = button.getAttribute("aria-controls");
		const target = document.querySelector(`#${targetId}`);

		if (!currentState || currentState === config.closedState) {
			button.setAttribute(config.stateAttribute, config.openState);
			button.setAttribute(config.expandedAttribute, "true");
			target.classList.add(config.openClass);

			body.classList.add("burger-menu-open");
		} else {
			closeBurger(button, config);
		}
	};

	// Initialisation
	const init = (userOptions = {}) => {
		const config = { ...defaults, ...userOptions };
		const buttons = document.querySelectorAll(config.selector);

		buttons.forEach((button) => {
			const targetId = button.getAttribute("aria-controls");
			const target = document.querySelector(`#${targetId}`);
			const navContent = target.querySelector(".extra-nav__ctn");

			// Clic sur le bouton → toggle
			button.addEventListener("click", (e) => {
				e.stopPropagation();
				toggleBurgerState(button, config);
			});

			// Clic sur .extra-nav mais PAS dans .extra-nav__ctn → ferme
			target.addEventListener("click", (e) => {
				if (navContent.contains(e.target)) {
					return; // clic à l'intérieur → on ne ferme pas
				}
				closeBurger(button, config);
			});
		});
	};

	return { init };
})();
